import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class NotesService {
  constructor(private api: ApiService) {}

  getUserNotes = (searchText: string, endDate: any, startDate: any) => {
    return this.api.get(
      `/user-notes?office_id=${this.api.getOfficeId()}&user_id=${this.api.getUserId()}&keyword=${searchText}&to=${endDate}&from=${startDate}`
    );
  };

  saveUserNotes = (payload: any) => {
    return this.api.post(`/user-notes`, payload);
  };

  updateUserNotes = (_id: string, payload: any) => {
    return this.api.put(`/user-notes/${_id}`, payload);
  };

  deleteNote = (id: string) => {
    return this.api.delete('/user-notes/' + id);
  };

  getAllNotes = () => {
    return this.api.get(`/user-notes?office_id=${this.api.getOfficeId()}&user_id=${this.api.getUserId()}`);
  };

  /**
   * Notes other users (or their teams) have shared with the logged-in user.
   * @param noteId When set, narrows the response to that single note (used when
   *               arriving from a "Note Shared" notification).
   */
  getSharedNotes = (noteId: string = '') => {
    const note = noteId ? `&noteId=${noteId}` : '';
    return this.api.get(`/user-notes?office_id=${this.api.getOfficeId()}&user_id=${this.api.getUserId()}&type=share${note}`);
  };
}
